import React from 'react';

import * as icons from './Icons';

interface IconProps {
  name: string;
  fill?: string;
  width?: string;
  height?: string;
  'data-testid'?: string;
}

const nameToComponentMap = {
  tag: icons.Tag,
  copy: icons.Copy,
  file: icons.File,
  link: icons.Link,
  loop: icons.Loop,
  note: icons.Note,
  bell: icons.Bell,
  goblet: icons.Goblet,
  column: icons.Column,
  repeat: icons.Repeat,
  delete: icons.Delete,
  remind: icons.Remind,
  mirror: icons.Mirror,
  related: icons.Related,
  comment: icons.Comment,
  history: icons.History,
  calendar: icons.Calendar,
  openInNew: icons.OpenInNew,
  subaction: icons.Subaction,
  addTo1on1: icons.AddTo1on1,
  effortLow: icons.EffortLow,
  effortHuge: icons.EffortHigh,
  workstream: icons.Workstream,
  statusNext: icons.StatusNext,
  statusDone: icons.StatusDone,
  convertToAi: icons.ConvertToAi,
  statusDoing: icons.StatusDoing,
  statusPause: icons.StatusPause,
  effortMedium: icons.EfforMedium,
  priorityHigh: icons.PriorityHigh,
  addToMeeting: icons.AddToMeeting,
  confidenceRed: icons.ConfidenceRed,
  accountSwitch: icons.AccountSwitch,
  priorityNormal: icons.PriorityNormal,
  priorityHighest: icons.PriorityHighest,
  confidenceGreen: icons.ConfidenceGreen,
  confidenceAmber: icons.ConfidenceAmber,
  commentOutlined: icons.CommentOutlined,
  attachmentVertical: icons.AttachmentVertical,
  subdirectoryArrowRight: icons.SubdirectoryArrowRight,
};

export default ({
  name,
  fill,
  width,
  height,
  'data-testid': dataTestId,
}: IconProps) => {
  const Component = nameToComponentMap[name];
  return Component ? (
    <Component
      data-testid={dataTestId ?? `test-icon-${name}`}
      fill={fill}
      width={width}
      height={height}
    />
  ) : null;
};
